import React, { useState } from "react";
import "./Hero.css";
import { Link } from "react-scroll";
import astro from "../assets/astronaut.png";

const Hero = () => {
  const [status, setStatus] = useState("idle");
  const startDate = new Date(2020, 4);
  const now = new Date();

  let years = now.getFullYear() - startDate.getFullYear();

  if (
    now.getMonth() < startDate.getMonth() ||
    (now.getMonth() === startDate.getMonth() &&
      now.getDate() < startDate.getDate())
  ) {
    years--;
  }

  const handleAstroClick = () => {
    setStatus("flyAway");
    setTimeout(() => {
      setStatus("flyBack");
    }, 10000);
  };

  return (
    <div className="hero" id="home">
      <div className="hero-overlay">
        <div className="description">
          <h2 className="title">Hello. I am Redi</h2>
          <h3 className="tagline">
            Full-stack developer with {years}+ years of experience
          </h3>
          <p className="paragraph">
            Skilled software developer with experience in JavaScript technologies
            and libraries. Experienced in designing user-friendly applications and
            working with various data structures. Skilled at collaborating in team
            environments to develop high-quality software solutions that meet user
            needs and ensure customer satisfaction. Strong problem-solving
            abilities with a focus on continuous improvement.
          </p>
          <div className="hero-btns">
            <button className="lets-talk">
              <Link spy smooth offset={50} duration={500} to="contact">
                LET'S TALK
              </Link>
            </button>
          </div>
        </div>

        <img
          src={astro}
          alt="redi"
          className={`hero-image ${
            status === "flyAway"
              ? "fly-away"
              : status === "flyBack"
              ? "fly-back"
              : ""
          }`}
          onClick={handleAstroClick}
        />
      </div>

      <div className="social-icons">
        <a href="https://github.com/RediIbra" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-github" />
        </a>
        <a
          href="https://www.linkedin.com/in/redi-ibra4/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin-in" />
        </a>
        <a
          href="https://www.instagram.com/redii_ibra/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/redi.ibra.31/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  );
};

export default Hero;
